"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addKeyHelpers = addKeyHelpers;
exports.addKeyIconHelpers = addKeyIconHelpers;
const taskSetup_1 = require("../../taskSetup");
const components_1 = require("./components");
const taskStore_1 = require("../../../taskStore");
// Adds key helper icons to buttons (centered inside) (left, right)
function addKeyHelpers(el, keyIndex, keyEmojis = components_1.arrowKeyEmojis) {
    if (!taskSetup_1.isTouchScreen) {
        const arrowKeyBorder = document.createElement('div');
        arrowKeyBorder.classList.add('arrow-key-border');
        arrowKeyBorder.style.position = 'absolute';
        arrowKeyBorder.style.inset = '0';
        arrowKeyBorder.style.display = 'flex';
        arrowKeyBorder.style.justifyContent = 'center';
        arrowKeyBorder.style.alignItems = 'center';
        el.style.position = 'relative';
        const arrowKey = document.createElement('p');
        arrowKey.innerHTML = keyEmojis[keyIndex][1];
        arrowKey.style.textAlign = 'center';
        arrowKey.style.margin = '0';
        arrowKeyBorder.appendChild(arrowKey);
        el.appendChild(arrowKeyBorder);
    }
}
// Adds key helper icons that sits outside the button (left, right, up, down)
function addKeyIconHelpers(el, keyIndex) {
    const { keyHelpers } = (0, taskStore_1.taskStore)();
    if (keyHelpers && !taskSetup_1.isTouchScreen) {
        const arrowKeyBorder = document.createElement('div');
        arrowKeyBorder.classList.add('arrow-key-border');
        const arrowKey = document.createElement('p');
        arrowKey.innerHTML = components_1.multipleArrowKeyEmojis[keyIndex][1];
        arrowKey.style.textAlign = 'center';
        arrowKey.style.margin = '0';
        arrowKeyBorder.appendChild(arrowKey);
        el.appendChild(arrowKeyBorder);
    }
}
